import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Loading } from '../../components/Loading/Loading';
import { isPaymentsTestingEnabled, useRuntimeFeatureFlags } from '../../services/featureFlags';
import { AdminPermission } from '../manageAdmin/AdminUserList.types';
import { useAdminUsers } from '../manageAdmin/context/AdminUsersContext';

export const usePaymentsTestingAccess = (
  requiredPermission:
    AdminPermission | readonly AdminPermission[] = AdminPermission.READ_PAYMENT_CLOSE
) => {
  const featureFlagsQuery = useRuntimeFeatureFlags();
  const { initialPermissionsLoaded, myPermissions } = useAdminUsers();
  const requiredPermissions = Array.isArray(requiredPermission)
    ? requiredPermission
    : [requiredPermission];
  const hasRequiredPermission = requiredPermissions.some((permission) =>
    myPermissions.includes(permission)
  );

  return {
    isLoading: featureFlagsQuery.isPending || !initialPermissionsLoaded,
    hasAccess:
      initialPermissionsLoaded &&
      !featureFlagsQuery.isError &&
      hasRequiredPermission &&
      isPaymentsTestingEnabled(featureFlagsQuery.data),
  };
};

export function PaymentsTestingRoute({
  children,
  requiredPermission,
}: {
  children: ReactNode;
  requiredPermission?: AdminPermission | readonly AdminPermission[];
}) {
  const { hasAccess, isLoading } = usePaymentsTestingAccess(requiredPermission);

  if (isLoading) {
    return (
      <div
        className="flex min-h-40 items-center justify-center"
        aria-label="Loading Payments access"
      >
        <Loading />
      </div>
    );
  }

  if (!hasAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
